import { render, staticRenderFns } from "./BaseTableResponsive.vue?vue&type=template&id=78c96a92&"
import script from "./BaseTableResponsive.vue?vue&type=script&lang=js&"
export * from "./BaseTableResponsive.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableResponsive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports